import React from 'react'
import styles from './styles/cashouts.module.css'

// Components
import { Advice } from './components/advice'
import { CashoutsTable } from '../Retirar/CahoutsTable'
import { TriggerCashoutModal } from './components/modal/trigger'
import { CashoutResume } from './components/cashout-resume/cashout-resume'

// Assets
import retirarIcon from '../../assets/images/retirarIconBlanco.png'
import flechas from '../../assets/images/flechasIconBlanco-50.png'

// Styles
import '../Payments/shared/payments.css'

export const Cashouts = ({ userData }) => {

  return (
    <div className='user-categories-container col-xs-12 col-md-9'>
      <div className={styles.container}>
        <div className={styles.title}>
          <img src={retirarIcon} className='title-icon' alt='Retirar' />
          <h1>RETIRAR</h1>
        </div>

        <Advice />
        <CashoutResume />
        <TriggerCashoutModal />

        <div className={styles.title}>
          <img src={flechas} className='title-icon' alt='Retirar' />
          <div>HISTORIAL DE RETIROS</div>
        </div>

        <CashoutsTable />
      </div>
    </div>
  )
}
